(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/debounce-input/assets/javascripts/debounce-inputv2.js') >= 0) return;  svs.modules.push('/components/lb-ui/debounce-input/assets/javascripts/debounce-inputv2.js');

'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Inputv2: Input
} = svs.ui.reactForm;
class DebounceInput extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      value: this.props.value
    });
    this.timer = null;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      value
    } = this.props;
    if (prevProps.value !== value) {
      this.setValue(value);
    }
  }
  setValue(val) {
    this.setState({
      value: val
    });
  }
  handleInputChange(event) {
    event.persist();
    this.setState({
      value: event.target.value
    });
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.props.onChange(event);
    }, this.props.debounceTime);
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.keyCode === 13 || event.which === 13) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.props.onChange(event);
    }
  }
  render() {
    const inputProps = Object.keys(this.props).filter(key => ['onChange', 'debounceTime'].indexOf(key) === -1).reduce((output, key) => _objectSpread(_objectSpread({}, output), {}, {
      [key]: this.props[key]
    }), {});
    return React.createElement(Input, _extends({}, inputProps, {
      onChange: this.handleInputChange,
      onKeyDown: this.handleKeyDown,
      value: this.state.value
    }));
  }
}
DebounceInput.defaultProps = {
  debounceTime: 250,
  value: ''
};
svs.lb_ui.debounceInput.DebounceInputV2 = DebounceInput;

 })(window);